import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { APP_PATHS } from '../config/app-paths';

export const AdminRouteIdGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const parsedId = Number(route.paramMap.get('id'));
  const redirectTo =
    route.data['invalidIdRedirect'] ?? `/${APP_PATHS.admin.root}`;

  if (Number.isInteger(parsedId) && parsedId > 0) {
    return true;
  }

  console.warn('[AdminRouteIdGuard] Invalid admin route id', {
    rawId: route.paramMap.get('id'),
    redirectTo,
    url: route.url.map((segment) => segment.path).join('/'),
  });

  return router.createUrlTree([redirectTo]);
};
